"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slider = exports.pagination = exports.navigation = exports.BANNERS_CAROUSEL = void 0;
const BANNERS_CAROUSEL = exports.BANNERS_CAROUSEL = 'top-area-banners-carousel';
const navigation = exports.navigation = {
  showArrows: false
};
const pagination = exports.pagination = {
  show: false
};
const slider = exports.slider = {
  drag: false
};